import { Button, Divider, Input, Select, SelectProps } from "antd"
import React, { useState } from "react"
import { Plus as PlusIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { getPopupAnchor } from "~Shared/utils/popup.utils"
import { unitOfMeasureOptions } from "../../shared/utils/form.utils"
import { FormSelectOption } from "./form.types"

interface UnitOfMeasureSelectProps extends SelectProps {}

export const UnitOfMeasureSelect = ({ value, onChange, placeholder, disabled, className }: UnitOfMeasureSelectProps) => {
    const { t } = useTranslation()

    const [customUnitOfMeasureOptions, setCustomUnitOfMeasureOptions] = useState<Array<FormSelectOption>>(unitOfMeasureOptions(t))
    const [customUnitOfMeasure, setCustomUnitOfMeasure] = useState<string>("")

    const renderUnitOfMeasureDropdown = (menu: React.ReactElement<any, string | React.JSXElementConstructor<any>>) => (
        <>
            {menu}
            <Divider className="my-6" />
            <Input.Group className="flex flex-row space-x-4" compact>
                <Input value={customUnitOfMeasure} onChange={(e) => setCustomUnitOfMeasure(e.target.value)} placeholder={t("input:add_custom_unit")} />
                <Button
                    onClick={() => {
                        if (customUnitOfMeasure.trim()) {
                            setCustomUnitOfMeasureOptions((prev) => [...prev, { param: customUnitOfMeasure, value: customUnitOfMeasure }])
                            setCustomUnitOfMeasure("")
                        }
                    }}
                    disabled={!customUnitOfMeasure.trim()}
                >
                    <PlusIcon />
                </Button>
            </Input.Group>
        </>
    )

    return (
        <Select
            value={value}
            onChange={onChange}
            getPopupContainer={getPopupAnchor()}
            dropdownRender={renderUnitOfMeasureDropdown}
            placeholder={placeholder}
            disabled={disabled}
            className={className}
        >
            {customUnitOfMeasureOptions.map((item) => (
                <Select.Option value={item.value} key={item.value}>
                    {item.param}
                </Select.Option>
            ))}
        </Select>
    )
}
